import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createGroupApi, updateGroupApi, deleteGroupApi } from '@/api';
import { projectSolarRoutes, projectSolarSiteinfoChildrenRoutes, projectEnergyRoutes, projectSituationRoomRoutes } from '@/router/routes';


import { mapState, mapActions, mapMutations } from 'vuex';
// <!>TODO 0. 將外層 solar project 同步塞到 otherSites 內 並注意順序 otherSites[2]
// <!>TODO 改為 各自獨立更新、可以收合群組? -> 先不用
// <!>TODO 1. 判斷至少選擇其中一個專案 -> 修改 api 結構
// <!>TODO 2. 製作選擇專案按鈕
// <!>TODO 3. 選擇專案後至少要選擇一項目
// <!>TODO 4. 若沒選擇即時資訊 則提醒 top 網頁也不會出現(?)
// <!>TODO 5. 調整 otherSites 順序(難) 介面與資料要同步改

var createOthersMenuDefault = [{
  menuName: '即時資訊 - 案場狀態告警',
  hasPermission: false,
  list: []
}, {
  menuName: '即時資訊 - 案場資訊(即時資訊)',
  hasPermission: false,
  list: []
}
// {
//   menuName: '測試測試',
//   hasPermission: false,
//   list: []
// }
];
export default {
  name: 'GroupManage',
  data: function data() {
    return {
      thTitle: ['等級', '可觀看 SIDE 網頁', '可觀看 TOP 網頁', '可使用項目', '其他專案'],
      data: [],
      othersMenuList: [
      // 用來 map 資料
      {
        menuName: '即時資訊 - 案場狀態告警',
        listName: '告警等級顯示項目',
        options: ['影響發電', '發電效率不佳', '不影響發電', '系統未連線', '系統短暫斷線']
      }, {
        menuName: '即時資訊 - 案場資訊(即時資訊)',
        listName: '即時資訊顯示項目',
        options: ['目前日照強度 (w/m²)', '今日日照量 (kWh/m²)', '今日峰瓩值 (kWh/kWp)', '今日 PR (%)', '低壓功率 (kW)', '高壓功率 (kW)', '模組溫度 (°C)', '環境溫度 (°C)', '即時風速 (m/s)', '即時風向 (°)', '即時水位值 (m)']
      }
      // {
      //   menuName: '測試測試',
      //   listName: '測試顯示項目',
      //   options: [
      //     '123', '321'
      //   ]
      // }
      ],
      otherSitesList: [{
        name: 'projectEnergy',
        sideMenu: [],
        componentMenu: [],
        othersMenu: []
      }, {
        name: 'projectSituationRoom',
        sideMenu: [],
        componentMenu: [],
        othersMenu: []
      }],
      createRoleName: '',
      // createSideMenu: [],
      // createComponentMenu: [],
      // createOthersMenu: JSON.parse(JSON.stringify(createOthersMenuDefault)),
      createSolarSideMenu: [],
      createSolarComponentMenu: [],
      createSolarOthersMenu: JSON.parse(JSON.stringify(createOthersMenuDefault)),
      createEnergySideMenu: [],
      createRoomSideMenu: [],
      createSolarDialog: false,
      createEnergyDialog: false,
      createRoomDialog: false,
      solarDialogs: [],
      // 記錄 太陽能雲端監控 dialog 是否開啟
      energyDialogs: [],
      // 記錄 電能可視化管理 dialog 是否開啟
      roomDialogs: [] // 記錄 能源儀表板 dialog 是否開啟
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['roleArray', 'userDetail'])), {}, {
    operator: function operator() {
      return this.userDetail.account;
    },
    managerRole: function managerRole() {
      return this.userDetail.role;
    },
    sideMenuOptions: function sideMenuOptions() {
      // 除去 realtime(即時資訊 任何權限皆可看), siteinfo (非 sideMenu 內容)
      return projectSolarRoutes.filter(function (x) {
        return x.meta && x.meta.release;
      }).map(function (route) {
        return {
          value: route.name,
          text: route.meta.zhTw
        };
      });
    },
    siteMenuSortList: function siteMenuSortList() {
      return this.sideMenuOptions.map(function (obj) {
        return obj.value;
      });
    },
    componentMenuOptions: function componentMenuOptions() {
      return projectSolarSiteinfoChildrenRoutes
      // .filter((x) => x.meta && x.meta.release) // 可以不用
      .map(function (route) {
        return {
          value: route.name,
          text: route.meta.zhTw
        };
      });
    },
    componentMenuSortList: function componentMenuSortList() {
      return this.componentMenuOptions.map(function (obj) {
        return obj.value;
      });
    },
    // ---------- 可視化 ----------
    energySideMenuOptions: function energySideMenuOptions() {
      return projectEnergyRoutes.map(function (route) {
        return {
          value: route.name,
          text: route.meta.zhTw
        };
      });
    },
    energySideMenuSortList: function energySideMenuSortList() {
      return this.energySideMenuOptions.map(function (obj) {
        return obj.value;
      });
    },
    // ---------- 能源儀表板 ----------
    roomSideMenuOptions: function roomSideMenuOptions() {
      return projectSituationRoomRoutes.map(function (route) {
        return {
          value: route.name,
          text: route.meta.zhTw
        };
      });
    },
    roomSideMenuSortList: function roomSideMenuSortList() {
      return this.roomSideMenuOptions.map(function (obj) {
        return obj.value;
      });
    },
    // ---------- 太陽能 ----------
    solarSideMenuOptions: function solarSideMenuOptions() {
      // 除去 realtime(即時資訊 任何權限皆可看), siteinfo (非 sideMenu 內容)
      return projectSolarRoutes.filter(function (x) {
        return x.meta && x.meta.release;
      }).map(function (route) {
        return {
          value: route.name,
          text: route.meta.zhTw
        };
      });
    },
    solarSideMenuSortList: function solarSideMenuSortList() {
      return this.solarSideMenuOptions.map(function (obj) {
        return obj.value;
      });
    },
    solarComponentMenuOptions: function solarComponentMenuOptions() {
      return projectSolarSiteinfoChildrenRoutes
      // .filter((x) => x.meta && x.meta.release) // 可以不用
      .map(function (route) {
        return {
          value: route.name,
          text: route.meta.zhTw
        };
      });
    },
    solarComponentMenuSortList: function solarComponentMenuSortList() {
      return this.solarComponentMenuOptions.map(function (obj) {
        return obj.value;
      });
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions(['getAllGroups'])), mapMutations(['UPDATE_ROLE_ARRAY'])), {}, {
    // 排序已選 sideMenu 項目
    sortSelectedSideMenu: function sortSelectedSideMenu(groupIdx) {
      var _this = this;
      if (groupIdx === 'createNew') {
        this.createSolarSideMenu.sort(function (a, b) {
          return _this.siteMenuSortList.indexOf(a) - _this.siteMenuSortList.indexOf(b);
        });
      } else {
        this.data[groupIdx].sideMenu.sort(function (a, b) {
          return _this.siteMenuSortList.indexOf(a) - _this.siteMenuSortList.indexOf(b);
        });
      }
    },
    // 排序已選 componentMenu 項目
    sortSelectedComponentMenu: function sortSelectedComponentMenu(groupIdx) {
      var _this2 = this;
      if (groupIdx === 'createNew') {
        this.createSolarComponentMenu.sort(function (a, b) {
          return _this2.componentMenuSortList.indexOf(a) - _this2.componentMenuSortList.indexOf(b);
        });
      } else {
        this.data[groupIdx].componentMenu.sort(function (a, b) {
          return _this2.componentMenuSortList.indexOf(a) - _this2.componentMenuSortList.indexOf(b);
        });
      }
    },
    // 取消勾選 othersMenu 清空項目
    handleSelectedOthersMenuTitle: function handleSelectedOthersMenuTitle(checked, groupIdx, listIdx) {
      if (!checked && groupIdx === 'createNew') {
        return this.createSolarOthersMenu[listIdx].list = [];
      }
      if (!checked) {
        return this.data[groupIdx].othersMenu[listIdx].list = [];
      }
    },
    // 排序已選告警等級項目
    sortSelectedOthersMenuList: function sortSelectedOthersMenuList(groupIdx, listIdx) {
      var _this3 = this;
      var sortedRule = function sortedRule(a, b) {
        return _this3.othersMenuList[listIdx].options.indexOf(a) - _this3.othersMenuList[listIdx].options.indexOf(b);
      };
      if (groupIdx === 'createNew') {
        this.createSolarOthersMenu[listIdx].list = this.createSolarOthersMenu[listIdx].list.sort(sortedRule);
      } else {
        this.data[groupIdx].othersMenu[listIdx].list = this.data[groupIdx].othersMenu[listIdx].list.sort(sortedRule);
        console.log(this.data[groupIdx].othersMenu[listIdx].list);
      }
    },
    // 排序已選 可視化 energy sideMenu 項目
    sortSelectedEnergySideMenu: function sortSelectedEnergySideMenu(groupIdx) {
      var _this4 = this;
      if (groupIdx === 'createNew') {
        this.createEnergySideMenu.sort(function (a, b) {
          return _this4.energySideMenuSortList.indexOf(a) - _this4.energySideMenuSortList.indexOf(b);
        });
      } else {
        this.data[groupIdx].otherSites[0].sideMenu.sort(function (a, b) {
          return _this4.energySideMenuSortList.indexOf(a) - _this4.energySideMenuSortList.indexOf(b);
        });
      }
    },
    // 排序已選 能源儀表板 room sideMenu 項目
    sortSelectedRoomSideMenu: function sortSelectedRoomSideMenu(groupIdx) {
      var _this5 = this;
      if (groupIdx === 'createNew') {
        this.createRoomSideMenu.sort(function (a, b) {
          return _this5.roomSideMenuSortList.indexOf(a) - _this5.roomSideMenuSortList.indexOf(b);
        });
      } else {
        this.data[groupIdx].otherSites[1].sideMenu.sort(function (a, b) {
          return _this5.roomSideMenuSortList.indexOf(a) - _this5.roomSideMenuSortList.indexOf(b);
        });
      }
    },
    // 排序已選 太陽能 solar sideMenu 項目
    sortSelectedSolarSideMenu: function sortSelectedSolarSideMenu(groupIdx) {
      // if (groupIdx === 'createNew') {
      //   this.createSolarSideMenu.sort(
      //     (a, b) =>
      //       this.solarSideMenuSortList.indexOf(a) -
      //       this.solarSideMenuSortList.indexOf(b)
      //   )
      // } else {
      //   this.data[groupIdx].otherSites[3].sideMenu.sort(
      //     (a, b) =>
      //       this.solarSideMenuSortList.indexOf(a) -
      //       this.solarSideMenuSortList.indexOf(b)
      //   )
      // }
    },
    // 排序已選 太陽能 solar componentMenu 項目
    sortSelectedSolarComponentMenu: function sortSelectedSolarComponentMenu(groupIdx) {
      // if (groupIdx === 'createNew') {
      //   this.createSolarComponentMenu.sort(
      //     (a, b) =>
      //       this.solarComponentMenuSortList.indexOf(a) -
      //       this.solarComponentMenuSortList.indexOf(b)
      //   )
      // } else {
      //   this.data[groupIdx].componentMenu.sort(
      //     (a, b) =>
      //       this.solarComponentMenuSortList.indexOf(a) -
      //       this.solarComponentMenuSortList.indexOf(b)
      //   )
      // }
    },
    loadData: function loadData() {
      var _this6 = this;
      var setDefaultOthersMenu = function setDefaultOthersMenu(obj) {
        var _obj$othersMenu$filte, _obj$othersMenu$filte2;
        var othersMenuArr = [];

        // 有的話放入 沒有的話補 default
        othersMenuArr[0] = ((_obj$othersMenu$filte = obj.othersMenu.filter(function (item) {
          return item.menuName === '即時資訊 - 案場狀態告警';
        })) === null || _obj$othersMenu$filte === void 0 ? void 0 : _obj$othersMenu$filte[0]) || _this6.othersMenuList[0];
        othersMenuArr[1] = ((_obj$othersMenu$filte2 = obj.othersMenu.filter(function (item) {
          return item.menuName === '即時資訊 - 案場資訊(即時資訊)';
        })) === null || _obj$othersMenu$filte2 === void 0 ? void 0 : _obj$othersMenu$filte2[0]) || _this6.othersMenuList[1];
        obj = _objectSpread(_objectSpread({}, obj), {}, {
          othersMenu: othersMenuArr
        });
        return obj;
      };
      var setDefaultOtherSitesMenu = function setDefaultOtherSitesMenu(obj) {
        var _obj$otherSites$filte, _obj$otherSites$filte2;
        var otherSitesArr = [];

        // 有的話放入 沒有的話補 default
        otherSitesArr[0] = ((_obj$otherSites$filte = obj.otherSites.filter(function (item) {
          return item.name === 'projectEnergy';
        })) === null || _obj$otherSites$filte === void 0 ? void 0 : _obj$otherSites$filte[0]) || _this6.otherSitesList[0];
        otherSitesArr[1] = ((_obj$otherSites$filte2 = obj.otherSites.filter(function (item) {
          return item.name === 'projectSituationRoom';
        })) === null || _obj$otherSites$filte2 === void 0 ? void 0 : _obj$otherSites$filte2[0]) || _this6.otherSitesList[1];
        obj = _objectSpread(_objectSpread({}, obj), {}, {
          otherSites: otherSitesArr
        });
        return obj;
      };

      // 非 Whole_Admin 不可看見 Whole_Admin 群組
      var copyRoleArray = JSON.parse(JSON.stringify(this.roleArray));
      var filteredArray = this.managerRole === 'Whole_Admin' ? copyRoleArray : copyRoleArray.filter(function (obj) {
        return obj.role !== 'Whole_Admin';
      });
      this.data = filteredArray.map(setDefaultOthersMenu).map(setDefaultOtherSitesMenu);
    },
    handleCreateGroupData: function handleCreateGroupData() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var hasUnfilledCreate, operator, role, sideMenu, componentMenu, othersMenu, otherSites, _createGroup$data, createGroup, _createGroup$data$msg, _error$msg;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this7.createRoleName === '')) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", _this7.$swal('請輸入等級名稱'));
              case 2:
                if (!_this7.data.find(function (obj) {
                  return obj.role === _this7.createRoleName;
                })) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", _this7.$swal('等級名稱與現有的重複'));
              case 4:
                hasUnfilledCreate = _this7.createSolarOthersMenu.some(function (obj) {
                  return obj.hasPermission && !obj.list.length;
                });
                if (!hasUnfilledCreate) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return", _this7.$swal('請檢查輸入 可使用項目設定'));
              case 7:
                // create
                operator = _this7.operator;
                role = _this7.createRoleName;
                sideMenu = _this7.createSolarSideMenu;
                componentMenu = _this7.createSolarComponentMenu;
                othersMenu = _this7.createSolarOthersMenu;
                otherSites = [{
                  name: 'projectEnergy',
                  sideMenu: _this7.createEnergySideMenu,
                  componentMenu: [],
                  othersMenu: []
                }, {
                  name: 'projectSituationRoom',
                  sideMenu: _this7.createRoomSideMenu,
                  componentMenu: [],
                  othersMenu: []
                }
                // <!>TODO 0
                // {
                //   name: 'projectSolar',
                //   sideMenu: this.createSolarSideMenu,
                //   componentMenu: [],
                //   othersMenu: []
                // }
                ];
                _context.prev = 13;
                _context.next = 16;
                return createGroupApi(operator, role, sideMenu, componentMenu, othersMenu, otherSites);
              case 16:
                createGroup = _context.sent;
                if (!(createGroup !== null && createGroup !== void 0 && (_createGroup$data = createGroup.data) !== null && _createGroup$data !== void 0 && _createGroup$data.success)) {
                  _context.next = 28;
                  break;
                }
                _this7.createRoleName = '';
                _this7.createSolarSideMenu = [];
                _this7.createSolarComponentMenu = [];
                _this7.createSolarOthersMenu = JSON.parse(JSON.stringify(createOthersMenuDefault));
                _this7.$swal('新增成功');
                _context.next = 25;
                return _this7.getAllGroups();
              case 25:
                _this7.loadData();
                _context.next = 29;
                break;
              case 28:
                _this7.$swal((_createGroup$data$msg = createGroup.data.msg) !== null && _createGroup$data$msg !== void 0 ? _createGroup$data$msg : '新增資料異常');
              case 29:
                _context.next = 35;
                break;
              case 31:
                _context.prev = 31;
                _context.t0 = _context["catch"](13);
                console.log('createGroupApi error', _context.t0);
                _this7.$swal((_error$msg = _context.t0.msg) !== null && _error$msg !== void 0 ? _error$msg : '新增資料異常');
              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[13, 31]]);
      }))();
    },
    handleUpdateGroupData: function handleUpdateGroupData() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var hasUnfilledAlertLevel, hasUnfilledSiteRealtimeInfo, promise, success;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // check
                hasUnfilledAlertLevel = _this8.data.map(function (obj) {
                  return obj.othersMenu[0].hasPermission && !obj.othersMenu[0].list.length;
                }).includes(true);
                if (!hasUnfilledAlertLevel) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return", _this8.$swal('請檢查輸入 告警等級顯示項目'));
              case 3:
                hasUnfilledSiteRealtimeInfo = _this8.data.map(function (obj) {
                  return obj.othersMenu[1].hasPermission && !obj.othersMenu[1].list.length;
                }).includes(true);
                if (!hasUnfilledSiteRealtimeInfo) {
                  _context2.next = 6;
                  break;
                }
                return _context2.abrupt("return", _this8.$swal('請檢查輸入 案場即時資訊顯示項目'));
              case 6:
                // update
                promise = [];
                _this8.data.forEach(function (obj) {
                  // 手動濾除舊內容項目 與目前有的選項一致(有需要再套入使用 測試時將 updateGroupApi 先commit掉)
                  // obj.sideMenu.filter((item) => this.siteMenuSortList.includes(item)),
                  promise.push(_this8.updateGroup(obj.id, obj.role, obj.sideMenu, obj.componentMenu, obj.othersMenu, obj.otherSites));
                });
                _context2.next = 10;
                return Promise.all(promise);
              case 10:
                success = _context2.sent;
                if (!success.every(function (isTrue) {
                  return isTrue;
                })) {
                  _context2.next = 19;
                  break;
                }
                _this8.$swal('更新成功');
                _context2.next = 15;
                return _this8.getAllGroups();
              case 15:
                _this8.UPDATE_ROLE_ARRAY();
                _this8.loadData();
                _context2.next = 20;
                break;
              case 19:
                _this8.$swal('更新資料異常');
              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    updateGroup: function updateGroup(id, role, sideMenu, componentMenu, othersMenu, otherSites) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _updateGroup$data;
        var updateGroup;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return updateGroupApi(id, _this9.operator, role, sideMenu, componentMenu, othersMenu, otherSites);
              case 2:
                updateGroup = _context3.sent;
                if (!(updateGroup !== null && updateGroup !== void 0 && (_updateGroup$data = updateGroup.data) !== null && _updateGroup$data !== void 0 && _updateGroup$data.success)) {
                  _context3.next = 5;
                  break;
                }
                return _context3.abrupt("return", true);
              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    handleDeleteGroupData: function handleDeleteGroupData(role, id) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // check delete
                _this10.$swal.fire({
                  title: "\u78BA\u5B9A\u8981\u522A\u9664\u6B64\u7FA4\u7D44?",
                  showDenyButton: true,
                  showCancelButton: false,
                  confirmButtonText: "\u78BA\u5B9A",
                  denyButtonText: "\u5426"
                }).then(function (result) {
                  return result.isConfirmed && _this10.deleteGroup(role, id);
                });
              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    deleteGroup: function deleteGroup(role, id) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _deleteGroup$data;
        var deleteGroup;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return deleteGroupApi(_this11.operator, role, id);
              case 2:
                deleteGroup = _context5.sent;
                if (!(deleteGroup !== null && deleteGroup !== void 0 && (_deleteGroup$data = deleteGroup.data) !== null && _deleteGroup$data !== void 0 && _deleteGroup$data.success)) {
                  _context5.next = 8;
                  break;
                }
                _this11.$swal('刪除成功');
                _context5.next = 7;
                return _this11.getAllGroups();
              case 7:
                _this11.loadData();
              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this12 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this12.loadData();
            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }
};